import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"icon-close\"><path d=\"M6.5 7.267L.746 13.021l-.767-.767L5.733 6.5-.021.746.746-.02 6.5 5.733l5.754-5.754.767.767L7.267 6.5l5.754 5.754-.767.767z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol